export const API_CUBE_CORE = process.env.API;
export const HEADERS = {
    'Content-Type': 'application/json',
};
